export const introduce = {
  name: "适 合 人 群",
  avatar: new URL("../img/teachers/course_intro.jpeg", import.meta.url) + "",
  title: ["有明确创业打算的女性", "女性初创业者（创业项目不满3年）"],
};

export default [
  {
    teachers: [
      introduce,
      {
        name: "鹿雯立",
        avatar: new URL("../img/teachers/鹿雯立.png", import.meta.url) + "",
        title: [
          "中国幸福教练联盟 发起人",
          "美国职业培训认证协会 培训师",
          "畅销书作家",
        ],
      },
      {
        name: "小佑",
        avatar: new URL("../img/teachers/小佑.png", import.meta.url) + "",
        title: ["成都蓝计划演示设计有限公司 项目总监"],
      },
    ],
  },
  {
    teachers: [
      introduce,
      {
        name: "冯岩",
        avatar: new URL("../img/teachers/冯岩.png", import.meta.url) + "",
        title: ["成都海川百纳商业管理有限公司 联合创始人", "江湖火锅 创始人"],
      },
      {
        name: "王婷",
        avatar: new URL("../img/teachers/王婷.png", import.meta.url) + "",
        title: ["汇智广通财务咨询 创始人"],
      },
    ],
  },
  {
    teachers: [
      introduce,
      {
        name: "Mercury",
        avatar: new URL("../img/teachers/Mercury.png", import.meta.url) + "",
        title: [
          "M Studio花与礼物 创始人",
          "全球最大媒介集团群邑中国 媒体策划总监",
          "群邑亚太区30位30岁以下年轻领导者之一",
        ],
      },
      {
        name: "Tommy Du",
        avatar: new URL("../img/teachers/Tommy_Du.png", import.meta.url) + "",
        title: [
          "Tommy & Brothers 高级定制 创始人",
          "Zegna 大区经理",
          "Stefano Ricci 大中华区 总监",
        ],
      },
    ],
  },
];
